import { render, staticRenderFns } from "./FlockCardFooter.vue?vue&type=template&id=18b5358a&scoped=true&"
import script from "./FlockCardFooter.vue?vue&type=script&lang=js&"
export * from "./FlockCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./FlockCardFooter.vue?vue&type=style&index=0&id=18b5358a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5358a",
  null
  
)

export default component.exports